import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="rem-footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Logo y Descripción */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/images/RemEnterprisesBlanco.png" alt="REM Enterprises" className="footer-logo-img" />
            </div>
            <p className="footer-description">
              Productos únicos y personalizados con la mejor calidad. 
              Diseños originales y tecnología AI para crear experiencias únicas.
            </p>
            <div className="footer-social">
              <a href="https://instagram.com/rementerprises" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=100032396396667" target="_blank" rel="noopener noreferrer" className="social-link">
                <i className="fa-brands fa-facebook"></i>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div className="footer-links">
            <h4 className="footer-title">Enlaces</h4>
            <ul className="footer-list">
              <li><Link to="/tienda"><i className="fa-solid fa-store me-2"></i>Tienda</Link></li>
              <li><Link to="/tienda?category=Remeras"><i className="fa-solid fa-shirt me-2"></i>Remeras</Link></li>
              <li><Link to="/tienda?category=Cuadros"><i className="fa-solid fa-image me-2"></i>Cuadros</Link></li>
              <li><Link to="/tienda?category=Almohadones"><i className="fa-solid fa-couch me-2"></i>Almohadones</Link></li>
              <li><Link to="/personalizados"><i className="fa-solid fa-pen-ruler me-2"></i>Personalizados</Link></li>
              <li><Link to="/personalizados/ia"><i className="fa-solid fa-wand-magic-sparkles me-2"></i>Personalizados IA</Link></li>
              <li><Link to="/merchandising"><i className="fa-solid fa-building me-2"></i>Merchandising</Link></li>
            </ul>
          </div>

          {/* Información */}
          <div className="footer-info">
            <h4 className="footer-title">Información</h4>
            <ul className="footer-list">
              <li><Link to="/cart"><i className="fa-solid fa-cart-shopping me-2"></i>Mi Carrito</Link></li>
              <li><Link to="/profile"><i className="fa-solid fa-user me-2"></i>Mi Cuenta</Link></li>
              <li><a href="mailto:contacto@rementerprises.uy"><i className="fa-solid fa-envelope me-2"></i>Contacto</a></li>
            </ul>
          </div>

          {/* AI y Métodos de Pago */}
          <div className="footer-extra">
            <h4 className="footer-title">Genera con IA</h4>
            <a 
              href="https://ai.rementerprises.uy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="ai-button"
            >
              <i className="fa-solid fa-wand-magic-sparkles me-2"></i>
              Crear Imágenes con IA
            </a>

            <h4 className="footer-title mt-4">Métodos de Pago</h4>
            <div className="payment-methods">
              <div className="payment-icon" title="Mercado Pago">
                <i className="fa-brands fa-cc-mastercard"></i>
              </div>
              <div className="payment-icon" title="Visa">
                <i className="fa-brands fa-cc-visa"></i>
              </div>
              <div className="payment-icon" title="American Express">
                <i className="fa-brands fa-cc-amex"></i>
              </div>
              <div className="payment-icon" title="Transferencia">
                <i className="fa-solid fa-building-columns"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; {new Date().getFullYear()} REM Enterprises. Todos los derechos reservados.
            </p>
            <p className="developer">
              Desarrollado por <a href="https://dev.moreira.uy" target="_blank" rel="noopener noreferrer">Moreira dev</a>
            </p>
          </div>
        </div>
      </div>

      <style>{`
        .rem-footer {
          background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
          color: #fff;
          padding: 0;
          margin-top: auto;
        }

        .footer-container {
          max-width: 1400px;
          margin: 0 auto;
        }

        .footer-main {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
          gap: 40px;
          padding: 60px 40px 40px;
        }

        .footer-brand {
          padding-right: 20px;
        }

        .footer-logo {
          margin-bottom: 20px;
        }

        .footer-logo-img {
          height: 40px;
          width: auto;
        }

        .footer-description {
          color: #aaa;
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .footer-social {
          display: flex;
          gap: 12px;
          justify-content: center;
        }

        .social-link {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255,255,255,0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 18px;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .social-link:hover {
          background: #1f8e38;
          color: #fff;
          transform: translateY(-3px);
        }

        .footer-title {
          color: #1f8e38;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .footer-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-list li {
          margin-bottom: 12px;
        }

        .footer-list a {
          color: #aaa;
          text-decoration: none;
          font-size: 14px;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
        }

        .footer-list a:hover {
          color: #1f8e38;
          padding-left: 5px;
        }

        .ai-button {
          display: inline-flex;
          align-items: center;
          padding: 12px 24px;
          background: linear-gradient(135deg, #1f8e38 0%, #25a000 100%);
          color: #fff;
          text-decoration: none;
          border-radius: 8px;
          font-weight: 600;
          font-size: 14px;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(31, 142, 56, 0.3);
        }

        .ai-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(31, 142, 56, 0.4);
          color: #fff;
        }

        .payment-methods {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .payment-icon {
          width: 45px;
          height: 30px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 18px;
        }

        .mercadopago-badge {
          margin-top: 15px;
        }

        .mp-badge {
          height: 35px;
          opacity: 0.9;
        }

        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding: 20px 40px;
        }

        .footer-bottom-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
        }

        .copyright {
          color: #666;
          font-size: 13px;
          margin: 0;
        }

        .developer {
          color: #666;
          font-size: 13px;
          margin: 0;
        }

        .developer a {
          color: #1f8e38;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .developer a:hover {
          color: #25a000;
        }

        /* Responsive */
        @media (max-width: 992px) {
          .footer-main {
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            padding: 40px 30px 30px;
          }
        }

        @media (max-width: 576px) {
          .footer-main {
            grid-template-columns: 1fr;
            gap: 30px;
            padding: 30px 20px;
            text-align: center;
          }

          .footer-brand {
            padding-right: 0;
          }

          .footer-social {
            justify-content: center;
          }

          .footer-list a {
            justify-content: center;
          }

          .payment-methods {
            justify-content: center;
          }

          .footer-bottom-content {
            flex-direction: column;
            text-align: center;
          }

          .ai-button {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
